import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO'
import isToday from 'date-fns/isToday'
import isTomorrow from 'date-fns/isTomorrow'
import axios from 'axios';
import config from '@wearetla/tla-essentials-tools/config';
import createI18nInstance from '/utilities/i18n/create-i18n-instance';
import { tr, enUS } from 'date-fns/locale'

const getNormalizedLanguage = (language) => (language || 'tr').split('-')[0].toLowerCase();
const getDateLocaleByLanguage = (language) => (getNormalizedLanguage(language) === 'en' ? enUS : tr);
const translatorCache = {};

const getTranslator = (language) => {
	const normalizedLanguage = getNormalizedLanguage(language);

	if (translatorCache[normalizedLanguage]) {
		return translatorCache[normalizedLanguage];
	}

	const t = createI18nInstance(normalizedLanguage).t;
	translatorCache[normalizedLanguage] = t;

	return t;
};

const getRelativeLabelsByLanguage = (language) => {
	const t = getTranslator(language);

	return {
		today: t('Bugün'),
		tomorrow: t('Yarın'),
		invalidDate: t('Hatalı Tarih'),
	};
};

const formatDate = (date, dateFormat = 'd MMMM yyyy', newOpts = {}) => {
	try {
		const resolvedLanguage =
			newOpts.language ||
			axios.defaults.headers.common?.language ||
			config.i18n?.defaultLanguage ||
			'tr';
		const labels = getRelativeLabelsByLanguage(resolvedLanguage);
		const resolvedLocale = newOpts.locale || getDateLocaleByLanguage(resolvedLanguage);

		let opts = {
			parsed: false,
			checkRelative: false,
			...newOpts,
		}
		if (date) {
			if (!opts.parsed) {
				date = parseISO(date);
			}
			if(opts.checkRelative && isToday(date)) {
				return labels.today;
			}
			else if(opts.checkRelative && isTomorrow(date)) {
				return labels.tomorrow;
			}
			else {
				return format(date, dateFormat, { locale: resolvedLocale, ...opts });
			}
		}
		else {
			return labels.invalidDate;
		}
	}
	catch(e) {
		console.warn('Format Date Error:', e);
		const fallbackLanguage =
			newOpts.language ||
			axios.defaults.headers.common?.language ||
			config.i18n?.defaultLanguage ||
			'tr';

		return getRelativeLabelsByLanguage(fallbackLanguage).invalidDate;
	}
}

export default formatDate